import { render } from "./PurchaseSheet.vue?vue&type=template&id=c84d89e8&ts=true"
import script from "./PurchaseSheet.vue?vue&type=script&lang=ts"
export * from "./PurchaseSheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__